/* eslint-disable react-hooks/exhaustive-deps */
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import {
  Alert,
  Box,
  Button,
  Chip,
  FormControlLabel,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { t } from "i18next";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  deleteManageByIdRefrsh,
  getMangeData,
} from "../../actions/mangeAction";
import { resetState } from "../../slices/manageSlice";

// import Loader from "../Loader";

import { Delete } from "@mui/icons-material";
import DeleteConfirmationModal from "../DeleteConfirmationModal/DeleteConfirmationModal";

import Progress from "../Loader/Progress ";
import DynamicSearchMenu from "../../pages/Booking/Components/searchOptionComponents/DynamicSearchMenu";
import {
  searchClient,
  searchMake,
  searchVehicleType,
} from "../../actions/formAction";
import MixSearch from "../List/MixSearch";
// headCells configuration for table columns
const headCells = [
  { id: "id", numeric: true, disablePadding: false, label: "ID" },
  { id: "name", numeric: false, disablePadding: false, label: "Name" },
  { id: "action", numeric: false, disablePadding: false, label: "Action" },
];


const headCellsConsignee = [
  { id: "id", numeric: true, disablePadding: false, label: "ID" },
  { id: "name", numeric: false, disablePadding: false, label: "Name" },
  { id: "street", numeric: false, disablePadding: false, label: "Street" },
  { id: "city", numeric: false, disablePadding: false, label: "City" },
  { id: "country", numeric: false, disablePadding: false, label: "Country" },
  { id: "email", numeric: false, disablePadding: false, label: "Email" },
  { id: "phoneNumber", numeric: false, disablePadding: false, label: "Phone Number" },
  { id: "action", numeric: false, disablePadding: false, label: "Action" },
];


// Create a data object from input fields

function createData(id, name, street, city, country, email, phoneNumber, consigneeNumber) {
  return { id, name, street, city, country, email, phoneNumber, consigneeNumber };
}
// Component for pagination actions in the table

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handlePageChange = (event, newPage) => {
    onPageChange(event, newPage);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={(event) => handlePageChange(event, 0)}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={(event) => handlePageChange(event, page - 1)}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={(event) => handlePageChange(event, page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={(event) =>
          handlePageChange(
            event,
            Math.max(0, Math.ceil(count / rowsPerPage) - 1)
          )
        }
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
// Component for the table head with sorting functionality

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, columns } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };



  const headCellsToUse = columns || headCells;

  return (
    <TableHead>
      <TableRow>
        {headCellsToUse.map((headCell, index) => (
          <TableCell
            key={index}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            variant="head"
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={headCell.id === 'action' ? undefined : createSortHandler(headCell.id)}
              disabled={headCell.id === 'action'}
            >
              {t(headCell.label).toUpperCase()}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
// Main component for the DataGridTable

const HasParentList = () => {
  const { mode } = useParams();
  const reducer = useSelector((state) => state.manage);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({ name: "", id: 0 });
  // Derived disabled state from parentId presence
  const location = useLocation();
  const theme = useTheme();

  const [dynamicSearchMenuParms, setDynamicSearchMenuParmsState] = useState({
      label: "",
      queryParam: "",
      loadingKey: "",
      dataKey: "",
      fetchAction: undefined,
  });

  const state = location.state;
  const { showSuccess, name } = state || false;

  useEffect(() => {
    switch (mode) {
      case "model":
        setDynamicSearchMenuParmsState({
          label: "Make",
          queryParam: "parentId",
          loadingKey: "isLoadingMakeData",
          dataKey: "make",
          fetchAction: searchMake,
        });
        break;
      case "make":
        setDynamicSearchMenuParmsState({
          label: "Vehicle Type",
          queryParam: "parentId",
          loadingKey: "isLoadingVehicleTypeData",
          dataKey: "vehicleType",
          fetchAction: searchVehicleType,
        });
        break;
      case "consignee":
        setDynamicSearchMenuParmsState({
          label: "Client",
          queryParam: "parentId",
          loadingKey: "isLoadingClientData",
          dataKey: "client",
          fetchAction: searchClient,
        });

        break;
      default:
        break;
    }
  }, [mode]);

  const data = reducer.object;
  const content = data.content || [];
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  const parentId = searchParams.get("parentId");
  useEffect(() => {
    if (parentId) {
      dispatch(getMangeData({ mode, query: searchParams.toString() }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, parentId, searchParams]);

  // URL query parameters and their setters
  const page = Number(searchParams.get("PageNumber")) || 0;
  const rowsPerPage = Number(searchParams.get("PageSize")) || 5;
  const order = searchParams.get("SortOrder") || "desc";
  const orderBy = searchParams.get("SortBy") || "id";

  const setParam = useCallback((key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value === null || value === undefined || value === "") {
      next.delete(key);
    } else {
      next.set(key, value);
    }
    setSearchParams(next);
  }, [searchParams, setSearchParams]);

  const setPage = (value) => setParam("PageNumber", value);


  // Sorting updates are applied atomically in handleRequestSort

  const [dense, setDense] = useState(true);

  const handleRequestSort = (event, property) => {
    if (property === 'action') return;
    const isAsc = orderBy === property && order === "asc";
    const nextOrder = isAsc ? "desc" : "asc";
    const next = new URLSearchParams(searchParams);
    next.set("SortOrder", nextOrder);
    next.set("SortBy", property);
    next.set("PageNumber", 0);
    setSearchParams(next);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value, 10);
    const next = new URLSearchParams(searchParams);
    if (!Number.isNaN(value)) {
      next.set("PageSize", value);
    } else {
      next.delete("PageSize");
    }
    next.set("PageNumber", 0);
    setSearchParams(next);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = () => {
    dispatch(
      deleteManageByIdRefrsh({
        mode,
        id: selectedItem.id,
        query: searchParams.toString(),
      })
    );
    handleCloseModal();
  };

  const handelEdit = (item) => {

    let path = mode === "consignee" ? "addConsignee" : "add";



    navigation(`/${mode}/${path}` + location.search, {
      state: {
        id: item.id,
        name: item.name,
        item: item,
      },
    });
  };

  // Table data preparation
  const rows = useMemo(() => content.map((e) => createData(e.id, e.name, e.street, e.city, e.country, e.email, e.phoneNumber, e?.consigneeNumber)), [content]);

  const handelAddNew = () => {

    if (mode === "consignee") {

      navigation(`/${mode}/addConsignee` + location.search);

    } else {

      navigation(`/${mode}/add` + location.search);

    }


  };



  const disabledButton = !parentId;

  const ConsigneeRow = ({row}) => mode === "consignee" ? (
    <>
      <TableCell>{row.street}</TableCell>
      <TableCell>{row.city}</TableCell>
      <TableCell>{row.country}</TableCell>
      <TableCell>{row.email}</TableCell>
      <TableCell>{row.phoneNumber}</TableCell>

    </>
  ) : <></>;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.totalElements) : 0;

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#F7F8FA",
        minHeight: "100vh",
        p: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          mb: 3,
          mt: { xs: 2, md: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 3,
            mt: { xs: 2, md: 0 },
          }}
        >
          <Typography
            variant="h4"
            sx={{ color: "#0B3C5D", fontWeight: 800, letterSpacing: 1 }}
          >
            {t(mode).toUpperCase()}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "end",
            justifyContent: "end",
            mb: 3,
          }}
        >
          <Button
            disabled={disabledButton}
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              borderRadius: 2,
              fontWeight: 700,
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            startIcon={
              <AddCircleOutlineIcon
                sx={{
                  color: theme.palette.secondary.main,
                  fontSize: 24,
                  bgcolor: theme.palette.background.paper,
                  borderRadius: "50%",
                }}
              />
            }
            onClick={() => handelAddNew()}
          >
            Add New {mode}
          </Button>
        </Box>
      </Box>

      <Paper
        sx={{
          p: { xs: 1, md: 3 },
          minHeight: 200,
          flexGrow: 1,
          mt: 3,
          background: "#fff",
          borderRadius: 4,
          boxShadow: "0 8px 32px 0 rgba(11, 60, 93, 0.10)",
          border: "1px solid #e9ecef",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: { xs: 2, md: 4 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "start",
            gap: 2,
            flexWrap: "wrap",
            minHeight: 70,
            borderRadius: 2,
            boxShadow: "0 1px 4px 0 rgba(11, 60, 93, 0.06)",
            bgcolor: theme.palette.background.default,


            mb: 3,
          }}
        >
          <Box sx={{ minWidth: { md: "350px", sm: "90%", xs: "90%" } }}>
            <DynamicSearchMenu
              label={dynamicSearchMenuParms.label}
              queryParam={dynamicSearchMenuParms.queryParam}
              loadingKey={dynamicSearchMenuParms.loadingKey}
              dataKey={dynamicSearchMenuParms.dataKey}
              fetchAction={dynamicSearchMenuParms.fetchAction}
              multiple={false}
              withExpandButton={false}
            />
          </Box>

          <Box sx={{ maxWidth: { md: "35%", sm: "40%", xs: "40%" } }}>
            <MixSearch />
          </Box>
        </Box>

        {showSuccess && (
          <Alert
            sx={{ m: 2 }}
            severity="success"
          >{`The ${mode.toLowerCase()} ${name}  has been saved successfully`}</Alert>
        )}

        {reducer.deleted && (
          <Alert sx={{ m: 2 }} severity="success">{`The ${mode.toLowerCase()} ${selectedItem.name
            }  has been deleted successfully`}</Alert>
        )}

        {reducer.error && (
          <Alert sx={{ m: 2 }} severity="error">{String(reducer.error)}</Alert>
        )}

        {reducer.loading === "pending" ? (
          <Progress Msg="Loading..." />
        ) : (
          <Box sx={{ width: "100%" }}>
            {!parentId ? (
              <Alert sx={{ m: 2 }} severity="info">{t('Please select a parent to view data')}</Alert>
            ) : rows.length === 0 ? (
              <Alert sx={{ m: 2 }} severity="info">{t('No results found')}</Alert>
            ) : null}
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer sx={{ overflowX: 'auto', maxHeight: 540 }}>
                <Table
                  stickyHeader
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    columns={mode === 'consignee' ? headCellsConsignee : headCells}
                  />
                  <TableBody>
                    {rows.map((row, index) => (
                      <React.Fragment key={row.id || index}>
                        <TableRow
                          sx={{
                            backgroundColor: index % 2 === 0 ? '#F7F8FA' : '#fff',
                            '&:hover': { backgroundColor: '#E9ECEF' },
                            transition: 'background 0.2s',
                          }}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <TableCell>{row.id}</TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                              <Typography noWrap title={row.name}>{row.name}</Typography>
                              {mode === 'consignee' && row.consigneeNumber ? (
                                <Chip size="small" variant="outlined" label={row.consigneeNumber} />
                              ) : null}
                            </Box>
                          </TableCell>

                          <ConsigneeRow row={row} />
                          <TableCell>
                            
                            <Tooltip title={t('Edit')}>
                              <span>
                                <IconButton
                                  disabled={disabledButton}
                                  onClick={() => handelEdit(row)}
                                  aria-label="Edit"
                                >
                                  <ModeEditIcon color="info" />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip title={t('Delete')}>
                              <span>
                                <IconButton
                                  disabled={disabledButton}
                                  onClick={() => handleOpenModal(row)}
                                  aria-label="Delete"
                                >
                                  <Delete color="error" />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{ height: (dense ? 33 : 53) * emptyRows }}
                      >
                        <TableCell colSpan={5} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={data.totalElements}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                ActionsComponent={TablePaginationActions}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label={t("Densepadding")}
            />

            {isModalOpen && (
              <DeleteConfirmationModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onDelete={handleDelete}
              />
            )}
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default HasParentList;
